import { BaseAction } from '../../store/actions';
import {
  LoginApiOptions,
  LoginStatus,
} from '../../shared/models/login';

export enum LoginActions {
  LoginRequest = '[Login] Make login',
  LoginSuccess = '[Login] Login Success',
  LoginError = '[Login] Login Error',
  Logout = '[Login] Logout',
  LogoutSuccess = '[Login] Logout Success',
  LogoutFailed = '[Login] Logout Failed',

  SessionExpired = '[Login] Session has expired',

  WatchExpiration = '[Login] Start Expiration Watch',
  ContinueWatchExpiration = '[Login] Continue Expiration Watch',
  StopWatchExpiration = '[Login] Stop Expiration Watch',
}

export class LoginRequest implements BaseAction<LoginActions> {
  readonly type = LoginActions.LoginRequest;

  constructor(public readonly apiOptions: LoginApiOptions) { }
}

export class LoginSuccess implements BaseAction<LoginActions> {
  readonly type = LoginActions.LoginSuccess;

  constructor(public readonly payload: LoginStatus) { }
}

export class LoginError implements BaseAction<LoginActions> {
  readonly type = LoginActions.LoginError;

  constructor(public readonly payload: LoginStatus) { }
}

export class Logout implements BaseAction<LoginActions> {
  readonly type = LoginActions.Logout;
}

export class LogoutSuccess implements BaseAction<LoginActions> {
  readonly type = LoginActions.LogoutSuccess;
}

export class LogoutFailed implements BaseAction<LoginActions> {
  readonly type = LoginActions.LogoutFailed;

  constructor(public readonly payload: string) {
  }
}

export class SessionExpired implements BaseAction<LoginActions> {
  readonly type = LoginActions.SessionExpired;
}

export class WatchExpiration implements BaseAction<LoginActions> {
  readonly type = LoginActions.WatchExpiration;
}

export class ContinueWatchExpiration implements BaseAction<LoginActions> {
  readonly type = LoginActions.ContinueWatchExpiration;
}

export class StopWatchExpiration implements BaseAction<LoginActions> {
  readonly type = LoginActions.StopWatchExpiration;
}

export type LoginAction = LoginRequest | LoginSuccess | LoginError | Logout | LogoutSuccess | LogoutFailed | WatchExpiration | ContinueWatchExpiration | StopWatchExpiration | SessionExpired;
